import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/Wraper.css";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
import AndarBahar from "../../games/AndarBahar/AndarBaharGames";
import AvailableGames from "../../games/AvailableGames/AvailableGames";
import StartLine from "../../games/StarLine/StartLine";
import Section4 from "../MainSection/Section4";
import GameRateSection from "../GameRates/GameRateSection";
const Rates = () => {
  return (
    <>
      <Navbar />
      {/* <Section2 /> */}
      {/* <Section3 /> */}
      <GameRateSection />
      <AvailableGames />
      <StartLine />
      <AndarBahar />
      <Section4 />
      {/* <FandQSection />
      <ContactUs /> */}
      <Footer />
    </>
  );
};

export default Rates;
